import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ModuleState } from '../reducers/module.reducer';
import { MODULE_FEATURE_KEY } from '../keys';

const selectState = createFeatureSelector<ModuleState>(MODULE_FEATURE_KEY);

export const selectLoaded = (id: string) => createSelector(selectState, (state: ModuleState) => (state.items[id] ? state.items[id].loaded : null));
export const selectLoading = (id: string) => createSelector(selectState, (state: ModuleState) => (state.items[id] ? state.items[id].loading : false));
export const selectModule = (id: string) => createSelector(selectState, (state: ModuleState) => (state.items[id] ? state.items[id].data : null));
